import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-726459a6")

_pushScopeId("data-v-726459a6")
const _hoisted_1 = {
  key: 0,
  style: {"overflow":"auto","position":"fixed","bottom":"14px","z-index":"99","width":"100%"}
}
const _hoisted_2 = {
  id: "AdBlockerComponent",
  class: "",
  "data-aos": "fade-up",
  "data-aos-anchor": "#AdBlockerComponent"
}
const _hoisted_3 = { class: "mx-auto max-w-4xl" }
const _hoisted_4 = { class: "float-right -mr-2 -mt-1" }
const _hoisted_5 = { class: "mt-3 mb-4 text-center sm:mt-0 sm:ml-4" }
const _hoisted_6 = {
  id: "modal-headline",
  class: "text-xl leading-6 font-medium text-gray-900 dark:text-gray-300"
}
const _hoisted_7 = { class: "mt-0 justify-center mx-auto px-4 pb-0 sm:px-6 sm:flex sm:flex-row-reverse" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_default_button = _resolveComponent("default-button")
  const _component_default_card_layout = _resolveComponent("default-card-layout")

  return (_ctx.hasAdblockerActivated())
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.showButton === true)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDialog && _ctx.toggleDialog(...args)))
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_btn_close, {
                "css-class": "absolute z-20",
                onClick: _ctx.cancelDialog
              }, null, 8, ["onClick"])
            ]),
            _createVNode(_component_default_card_layout, { class: "mx-4" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("modal.AdBlockerDialog.adBlockerText")), 1)
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", null, [
                    _createVNode(_component_default_button, {
                      "button-text": _ctx.$t('modal.AdBlockerDialog.buttonText'),
                      "button-color": "bg-bp",
                      "button-width": "w-5/6",
                      "button-x-margin": "mx-auto",
                      "button-x-padding": "px-1 sm:px-12",
                      class: "mb-0",
                      style: {"margin-block":"initial","margin-bottom":"1rem"},
                      onClick: _ctx.confirm
                    }, null, 8, ["button-text", "onClick"])
                  ]),
                  _createVNode("div", null, [
                    _createVNode(_component_default_button, {
                      "button-text": _ctx.$t('modal.AdBlockerDialog.buttonText2'),
                      "button-color": "bg-gray-200 dark:bg-gray-600",
                      "button-width": "w-5/6",
                      "button-x-margin": "mx-auto",
                      "button-x-padding": "px-1 sm:px-12",
                      class: "mb-0",
                      style: {"margin-block":"initial","margin-bottom":"0rem"},
                      onClick: _ctx.cancelDialog
                    }, null, 8, ["button-text", "onClick"])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ], 512), [
          [_vShow, _ctx.dialogVisible]
        ])
      ]))
    : _createCommentVNode("", true)
})